export const formatGet = value => value ? value.value : null;
export const formatSet = priceRaw => value => ({
  priceRaw,
  value
});